import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import {
  placeholderNoOptions,
  placeholderSelectSimple,
  placeholderText,
} from "../../../../shared/helpers/placeHolders";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { documentTypeEnum } from "../../../../shared/selectors/documentTypeEnum";
import {
  to_ICountry,
  to_ISelect_Entity,
  to_ISelect_Entity_Array,
  to_ISelect_Enum,
} from "../../../../shared/mutator/dataTransformSelect";
import { IRootState } from "../../../../reducers";
import { connect } from "react-redux";
import { genderEnum } from "../../../../shared/selectors/genderEnum";
import { customStyles } from "../custom-selector-styles";
import {
  validateCandidate,
  createCode,
} from "../../../../reducers/codeReducer";

interface IProps extends StateProps, DispatchProps {
  formik: any;
  setShowModal: (data: boolean) => void;
  setShowDocExists: (data: boolean) => void;
  setShowCode: (data: boolean) => void;
  setShowSaved: (data: boolean) => void;
  showErrorsInputs: boolean;
}

const animatedComponents = makeAnimated();

export const PersonalData = (props: IProps) => {
  const params: { idapplication: any } = useParams();
  const { formik, formData, validation, showErrorsInputs } = props;
  const validate = async () => {
    await formik.validateForm();
  };

  const inputDocument = useRef(null);
  const [disableField, setdisableField] = useState(false);

  const handleInputDocument = () => {
    formik.setFieldTouched("person.document");
    if (
      document.activeElement !== inputDocument.current &&
      typeof formik.values.person.document === "string" &&
      formik.values.person.document.length >= 7 && formik.values.person.document.length <= 9 &&
      !validation.mail
    ) {
      props.validateCandidate(
        formik.values.person.document,
        params?.idapplication
      );
    }
  };

  useEffect(() => {
    validate();
  }, [formik.values.person.country]);

  useEffect(() => {
    if (props.candidate?.id) {
      setdisableField(!disableField);
    }
  }, [formik.values.person.document, props.candidate]);

  useEffect(() => {
    if (validation.mail?.length && !validation.status_code) {
      props.createCode({ candidate_id: validation.candidate_id });
      props.setShowModal(true);
      props.setShowDocExists(true);
    }
  }, [validation.mail]);

  return (
    <>
      <Row className="title-form">Datos personales</Row>
      <Row className="container-inputs-form">
        <Col>
          <FormGroup>
            <Label
              id="firstNameLabel"
              for="person.firstName"
              className={
                (formik.touched?.person?.firstName || showErrorsInputs) &&
                formik.errors?.person?.firstName ? "text-danger"
                : ""
              }
            >
              Nombres*
            </Label>
            <Input
              type="text"
              name="person.firstName"
              onChange={formik.handleChange("person.firstName")}
              onBlur={formik.handleBlur("person.firstName")}
              value={formik.values.person.firstName}
              className={`form-control ${
                (formik.touched?.person?.firstName || showErrorsInputs) &&
                formik.errors?.person?.firstName &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(formik.touched?.person?.firstName || showErrorsInputs) &&
              formik.errors?.person?.firstName && (
                <div className="invalid-feedback">
                  {formik.errors.person.firstName}
                </div>
              )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label
              id="lastNameLabel"
              for="person.lastName"
              className={
                (formik.touched?.person?.lastName || showErrorsInputs) &&
                formik.errors?.person?.lastName ? "text-danger"
                : ""
              }
            >
              Apellidos*
            </Label>
            <Input
              type="text"
              name="person.lastName"
              onChange={formik.handleChange("person.lastName")}
              onBlur={formik.handleBlur("person.lastName")}
              value={formik.values.person.lastName}
              className={`form-control ${
                (formik.touched?.person?.lastName || showErrorsInputs) &&
                formik.errors?.person?.lastName &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(formik.touched?.person?.lastName || showErrorsInputs) &&
              formik.errors?.person?.lastName && (
                <div className="invalid-feedback">
                  {formik.errors.person.lastName}
                </div>
              )}
          </FormGroup>
        </Col>
      </Row>
      <Row className="container-inputs-form">
        <Col>
          <FormGroup>
            <Label
              id="documentTypeLabel"
              for="person.documentType"
              className={
                (formik.touched?.person?.document || showErrorsInputs) &&
                (formik.errors?.person?.documentType ||
                  formik.errors?.person?.document)
                  ? "text-danger"
                  : ""
              }
            >
              Tipo y nro documento*
            </Label>
            <Row className="input-document-group">
              <Col md="4" xs="4">
                <Select
                  isDisabled={disableField}
                  name="person.documentType"
                  placeholder={""}
                  noOptionsMessage={() => placeholderNoOptions()}
                  components={animatedComponents}
                  options={documentTypeEnum()}
                  value={to_ISelect_Enum(
                    formik.values.person.documentType,
                    documentTypeEnum()
                  )}
                  onChange={(e: any) => {
                    formik.setFieldValue("person.documentType", e.value);
                  }}
                  onBlur={formik.handleBlur("person.documentType")}
                  className={`select-postulate ${
                    (formik.touched?.person?.documentType ||
                      showErrorsInputs) &&
                    formik.values?.person?.documentType === null &&
                    "is-invalid"
                  }`}
                  styles={customStyles}
                />
                {(formik.touched?.person?.documentType || showErrorsInputs) &&
                  formik.values?.person?.documentType === null && (
                    <div className="invalid-feedback">
                      {formik.errors.person.documentType}
                    </div>
                  )}
              </Col>
              <Col md="8" xs="8">
                <FormGroup>
                  <Input
                    disabled={disableField}
                    type="text"
                    name="person.document"
                    onChange={formik.handleChange("person.document")}
                    onBlur={handleInputDocument}
                    value={formik.values.person.document}
                    className={`form-control ${
                      (formik.touched?.person?.document || showErrorsInputs) &&
                      formik.errors?.person?.document &&
                      "is-invalid"
                    }`}
                    placeholder={placeholderText()}
                    ref={inputDocument}
                  />
                  {(formik.touched?.person?.document || showErrorsInputs) &&
                    formik.errors?.person?.document && (
                      <div className="invalid-feedback">
                        {formik.errors.person.document}
                      </div>
                    )}
                </FormGroup>
              </Col>
            </Row>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label
              id="birthDateLabel"
              for="person.birthDate"
              className={
                (formik.touched?.person?.birthDate || showErrorsInputs) &&
                formik.errors?.person?.birthDate ? "text-danger"
                : ""
              }
            >
              Fecha de nacimiento*
            </Label>
            <Input
              type="date"
              name="person.birthDate"
              onChange={formik.handleChange("person.birthDate")}
              onBlur={formik.handleBlur("person.birthDate")}
              value={formik.values.person.birthDate}
              className={`form-control ${
                (formik.touched?.person?.birthDate || showErrorsInputs) &&
                formik.errors?.person?.birthDate &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(formik.touched?.person?.birthDate || showErrorsInputs) &&
              formik.errors?.person?.birthDate && (
                <div className="invalid-feedback">
                  {formik.errors.person.birthDate}
                </div>
              )}
          </FormGroup>
        </Col>
      </Row>
      <Row className="container-inputs-form">
        <Col>
          <FormGroup>
            <Label
              id="genderLabel"
              for="person.gender"
              className={
                (formik.touched?.person?.gender || showErrorsInputs) &&
                formik.errors?.person?.gender
                  ? "text-danger"
                  : ""
              }
            >
              Género*
            </Label>
            <Select
              name="person.gender"
              placeholder={placeholderSelectSimple()}
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              options={genderEnum()}
              value={to_ISelect_Enum(formik.values.person.gender, genderEnum())}
              onChange={(e: any) => {
                formik.setFieldValue("person.gender", e.value);
              }}
              onBlur={formik.handleBlur("person.gender")}
              className={`select-postulate ${
                (formik.touched?.person?.gender || showErrorsInputs) &&
                formik.values?.person?.gender === null &&
                "is-invalid"
              }`}
              styles={customStyles}
            />
            {(formik.touched?.person?.gender || showErrorsInputs) &&
              formik.values?.person?.gender === null && (
                <div className="invalid-feedback">
                  {formik.errors.person.gender}
                </div>
              )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label
              id="countryLabel"
              for="person.country"
              className={
                formik.touched?.person?.country || showErrorsInputs
                  ? formik.values?.person?.country === null
                    ? "text-danger"
                    : ""
                  : ""
              }
            >
              País de su nacionalidad*
            </Label>
            <Select
              name="person.country"
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              options={
                formData.countries
                  ? to_ISelect_Entity_Array(formData.countries)
                  : []
              }
              value={to_ISelect_Entity(formik.values.person.country)}
              onChange={(e: any) => {
                formik.setFieldValue("person.country", to_ICountry(e));
                formik.setFieldTouched("person.country");
              }}
              onBlur={formik.handleBlur("person.country")}
              placeholder={placeholderSelectSimple()}
              className={`select-postulate ${
                (formik.touched?.person?.country || showErrorsInputs) &&
                formik.values?.person?.country === null &&
                "is-invalid"
              }`}
              styles={customStyles}
            />
            {(formik.touched?.person?.country || showErrorsInputs) &&
              formik.values?.person?.country === null && (
                <div className="invalid-feedback">
                  {formik.errors?.person?.country}
                </div>
              )}
          </FormGroup>
        </Col>
      </Row>
      <Row className="container-inputs-form">
        <Col md="6">
          <FormGroup>
            <Label
              id="cuilLabel"
              for="person.cuil"
              className={
                (formik.touched?.person?.cuil || showErrorsInputs) &&
                formik.errors?.person?.cuil ? "text-danger"
                : ""
              }
            >
              CUIL*
            </Label>
            <Input
              type="text"
              name="person.cuil"
              onChange={formik.handleChange("person.cuil")}
              onBlur={formik.handleBlur("person.cuil")}
              value={formik.values.person.cuil}
              className={`form-control ${
                (formik.touched?.person?.cuil || showErrorsInputs) &&
                formik.errors?.person?.cuil &&
                "is-invalid"
              }`}
              placeholder={placeholderText()}
            />
            {(formik.touched?.person?.cuil || showErrorsInputs) &&
              formik.errors?.person?.cuil && (
                <div className="invalid-feedback">
                  {formik.errors.person.cuil}
                </div>
              )}
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};
const mapStateToProps = (state: IRootState) => {
  return {
    candidate: state.candidateReducer.entity,
    formData: state.postulateReducer.entities,
    loading: state.postulateReducer.loading,
    loadingCode: state.codeReducer.loading,
    validation: state.codeReducer.entity,
  };
};
const mapDispatchToProps = {
  validateCandidate,
  createCode,
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PersonalData);
